import { Component, Input } from '@angular/core';

@Component({
  selector: 'doctor-gui-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() class: string;
}
